<!-- anzeigen wann der Artikel eines Sicherheitsdatenblattes zuletzt verwendet wurde -->
<template>

    <span class="SicherheitsdatenblaetterZuletztVerwendet" v-if="datum">

      <java-date-to-default-date-format v-model="datum" />

    </span>

</template>

<script>

    import axios from 'axios'
    axios.defaults.withCredentials = true
    import JavaDateToDefaultDateFormat from '@/components/layout/JavaDateToDefaultDateFormat.vue'

    export default {
      name: 'SicherheitsdatenblaetterZuletztVerwendet',
      components: { JavaDateToDefaultDateFormat },
      props: ['article_id'],
      data () {
          return {
            datum: null,
          }
      },
      created () {
        this.randomer =  '' + Math.random()
        this.init()
      },
      watch: {

        article_id: function () {

          this.init()

        }

      },
      methods: {

        init: function () {

          this.datum = null

          if (this.article_id && this.$store.getters.customer) {

            const url = process.env.VUE_APP_SERVER_URL + '/datenbroker/artikelLetzteVerwendung'
            const that = this
            const params = {
              article_id:  this.article_id,
              customer_id: this.$store.getters.customer.id,
            }
            axios({
              method: 'GET',
              params: params,
              url: url,
            }).then(function (response) {

              that.datum = response.data.datum

            }).catch(error => {
              console.log(error)
            })

          }

        },

      }

    }

</script>
